/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 33 33',
    data: '<path pid="0" d="M1 33h.3l1.2-.4a237.6 237.6 0 017.8-2.6 2255.5 2255.5 0 0120-19.8c.5-.6 1-1.2 1.3-1.9a4.3 4.3 0 000-4c-.4-.5-.9-1.2-1.5-1.7-.5-.6-1-1-1.7-1.2-.6-.3-1.2-.4-1.8-.4-1 0-1.9.2-2.6.7-.7.4-1.1.8-1.3 1a207.8 207.8 0 00-9.4 9.4L3 22.5l-.1.2-.2.2a55.7 55.7 0 01-1.4 5A4257.1 4257.1 0 000 32.3l.3.4.3.3H1zM28.6 9A8 8 0 0024 4.3V4l.8-.6a2.8 2.8 0 012.8-.2l1 .7c.4.4.8.8 1 1.2l.3 1.2-.3 1.2a4.9 4.9 0 01-1 1.3l-.1.1zM10.4 27a10 10 0 00-1.7-2.5 8.5 8.5 0 00-3-2L9.3 19a2048.4 2048.4 0 008.4-8.5L19.3 9a461 461 0 013-3l1.3.4a6.6 6.6 0 013 3.2l.3 1.2A746.3 746.3 0 0010.4 27zm-8 3.6a453.8 453.8 0 012-6.4c.3 0 .7.2 1.2.5a6.6 6.6 0 013.2 3.7l-.5.2a830.2 830.2 0 00-6 2z"/>'
  }
})
